import React, { useState } from "react"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Button, IconButton, Menu, MenuItem } from "@mui/material"

function ContextMenu({ options, button }) {
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (e) => {
        e.stopPropagation()
        setAnchorEl(null)
    }

    return (
        <>
            {button ? (
                <Button
                    variant={button.variant || "contained"}
                    color={button.color || "primary"}
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? "long-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    {button.label}
                </Button>
            ) : (
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? "long-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVertIcon />
                </IconButton>
            )}
            <Menu
                id="long-menu"
                MenuListProps={{
                    "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        elevation: 0,
                        sx: {
                            boxShadow: "none",
                            border: "solid 1px #e3e3e3",
                        },
                    },
                }}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} onClick={() => option.handler?.()}>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

export default ContextMenu
